<template>
  <div>
    <v-expansion-panel v-model="panel" expand>
      <v-expansion-panel-content v-if="entity.type.contact">
        <template v-slot:header>
          <h2>Raw data contact</h2>
        </template>
        <v-card>
          <v-card-text>
            <table border="1">
              <tr>
                <th>Id</th>
                <th>Type id</th>
                <th>Type</th>
                <th>Body</th>
                <th>Archived</th>
                <th>User</th>
                <th>Timestamp</th>
                <th />
              </tr>
              <tr v-for="detail in entity.details" :key="detail.id">
                <td>{{ detail.id }}</td>
                <td>
                  <span v-if="detail.detailtype">{{
                    detail.detailtype.id
                  }}</span>
                </td>
                <td>
                  <span v-if="detail.detailtype">{{
                    detail.detailtype.name
                  }}</span>
                </td>
                <td>
                  <input
                    :value="detail.body"
                    @input="updateDetail(detail, $event.target.value)"
                  />
                </td>
                <td>
                  <span v-if="detail.archived">{{
                    detail.archived | formatDateTime
                  }}</span>
                  <v-btn
                    v-if="detail.archived"
                    @click="archiveDetail(detail, false)"
                    small
                    >Unarchive</v-btn
                  >
                  <v-btn
                    v-if="!detail.archived"
                    @click="archiveDetail(detail, true)"
                    small
                    >Archive</v-btn
                  >
                </td>
                <td>
                  <span v-if="!detail.user">{{ detail.userid }}</span>
                  <EntityZ
                    :entity="detail.user"
                    format="system"
                    v-if="detail.user"
                  />
                </td>
                <td>{{ detail.timestamp | formatDateTime }}</td>
                <td>
                  <v-btn @click="deleteDetail(detail)" small>Delete</v-btn>
                </td>
              </tr>
            </table>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
      <v-expansion-panel-content v-if="entity.type.address > 0">
        <template v-slot:header>
          <h2>Raw data address</h2>
        </template>
        <v-card>
          <v-card-text>
            <table border="1">
              <tr>
                <th>Address link id</th>
                <th>Address</th>
                <th>Archived</th>
                <th>User</th>
                <th>Timestamp</th>
                <th />
              </tr>
              <tr
                v-for="addressLink in entity.addressLinks"
                :key="addressLink.id"
              >
                <td>{{ addressLink.id }}</td>
                <td>
                  <span v-if="!addressLink.address">{{
                    addressLink.addressid
                  }}</span>
                  <span
                    v-if="addressLink.address"
                    style="white-space: pre-wrap"
                    >{{ addressLink.address.address }}</span
                  >
                </td>
                <td>
                  <span v-if="addressLink.archived">{{
                    addressLink.archived | formatDateTime
                  }}</span>
                  <v-btn
                    v-if="addressLink.archived"
                    @click="archiveAddressLink(addressLink, false)"
                    small
                    >Unarchive</v-btn
                  >
                  <v-btn
                    v-if="!addressLink.archived"
                    @click="archiveAddressLink(addressLink, true)"
                    small
                    >Archive</v-btn
                  >
                </td>
                <td>
                  <span v-if="!addressLink.user">{{ addressLink.userid }}</span>
                  <EntityZ
                    :entity="addressLink.user"
                    format="system"
                    v-if="addressLink.user"
                  />
                </td>
                <td>{{ addressLink.timestamp | formatDateTime }}</td>
                <td>
                  <v-btn @click="deleteAddressLink(addressLink)" small
                    >Delete</v-btn
                  >
                </td>
              </tr>
            </table>
            <v-btn @click="updateAddressLinksRepair">Fix address links</v-btn>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      :timeout="3000"
      :top="true"
    >
      {{ snackbarText }}
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import UPDATE_ENTITY_ADDRESSLINK_ARCHIVED from "@/graphql/directory/UpdateEntityAddressLinkArchived";
import UPDATE_ENTITY_ADDRESSLINKS_REPAIR from "@/graphql/directory/UpdateEntityAddressLinksRepair";
import UPDATE_ENTITY_DETAIL_ARCHIVED from "@/graphql/directory/UpdateEntityDetailArchived";
import UPDATE_ENTITY_DETAIL_BODY from "@/graphql/directory/UpdateEntityDetailBody";
import DELETE_ENTITY_ADDRESSLINK from "@/graphql/directory/DeleteEntityAddressLink";
import DELETE_ENTITY_DETAIL from "@/graphql/directory/DeleteEntityDetail";
import EntityZ from "@/components/link/EntityZ";
export default {
  name: "RawData",
  props: ["entity"],
  components: {
    EntityZ
  },
  data() {
    return {
      panel: [],
      snackbar: false,
      snackbarText: null,
      timerId: null
    };
  },
  methods: {
    updateDetail(detail, body) {
      // debounce
      clearTimeout(this.timerId);
      this.timerId = setTimeout(async () => {
        await this.$apollo.mutate({
          mutation: UPDATE_ENTITY_DETAIL_BODY,
          variables: {
            id: Number(this.$route.params.id),
            detailid: detail.id,
            body
          }
        });
        // console.log(response.data);
        this.$emit("triggerUpdate");
        this.snackbar = true;
        this.snackbarText = "Detail body updated";
      }, 1500);
    },
    async updateAddressLinksRepair() {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_ADDRESSLINKS_REPAIR,
        variables: {
          id: Number(this.$route.params.id)
        }
      });
      this.$emit("triggerUpdate");
    },
    async archiveDetail(detail, archived) {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_DETAIL_ARCHIVED,
        variables: {
          id: Number(this.$route.params.id),
          detailid: detail.id,
          archived
        }
      });
      // console.log(response.data);
      this.$emit("triggerUpdate");
    },
    async deleteDetail(detail) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: DELETE_ENTITY_DETAIL,
          variables: {
            id: Number(this.$route.params.id),
            detailid: detail.id
          }
        });
        // console.log(response.data);
        this.$emit("triggerUpdate");
      }
    },
    async archiveAddressLink(addressLink, archived) {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_ADDRESSLINK_ARCHIVED,
        variables: {
          id: Number(this.$route.params.id),
          addresslinkid: addressLink.id,
          archived
        }
      });
      // console.log(response.data);
      this.$emit("triggerUpdate");
    },
    async deleteAddressLink(addressLink) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: DELETE_ENTITY_ADDRESSLINK,
          variables: {
            id: Number(this.$route.params.id),
            addresslinkid: addressLink.id
          }
        });
        // console.log(response.data);
        this.$emit("triggerUpdate");
      }
    }
  }
};
</script>

<style scoped>
.row td {
  cursor: pointer;
}
table.v-table thead th {
  font-size: 9px !important;
  padding: 0px;
}
/* also tried table.v-table thead tr th {  */
table.v-table tbody tr td {
  font-size: 9px;
  height: 9px;
  padding: 0px;
}
</style>